<template functional>
  <div class="shop-by-campaign">
    <h2 class="page-title">{{ props.title }}</h2>
    <div class="shop-by-campaign-images columns is-multiline is-mobile">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopByCampaign',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-by-campaign {
  @include mobile {
    background-color: $grey-light;
    padding-bottom: 30px;
    padding-top: 10px;
  }

  .shop-by-campaign-images {
    @include mobile {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
</style>
